// extracted by mini-css-extract-plugin
module.exports = {"nav":"_5Qw2y","list":"x1v0Y","theme_main":"I80pN","item":"tIhEC","theme_footer":"Yo6Pa","link":"wA6Ax","type_mobile":"q0PDF"};